export type CookieStatus = 'accepted' | 'rejected' | 'undecided'

export type CookieSettingsState = { cookieStatus: CookieStatus }

export const cookiesAcceptedEvent = 'cookies_accepted'

export function setCookie(cname: string, cvalue: string, exdays: number) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname: string) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export const getCookieStatus = () : CookieStatus => {
  const cookiesCookie = getCookie('cookies')
  return cookiesCookie  == 'accepted'
    ? 'accepted'
    : cookiesCookie == 'rejected'
      ? 'rejected'
      : 'undecided'
}

export const updateCookieStatus = (s: CookieSettingsState): CookieSettingsState => ({...s, cookieStatus: getCookieStatus()})

